<template>
    <div id="recruitment">
        <!-- HERO -->
        <section class="rec-hero">
            <div class="hero-bg"></div>
            <div class="hero-overlay"></div>
            <div class="hero-grain"></div>

            <div class="hero-top">
                <span class="hero-brand">AGH SOLAR BOAT</span>
                <span class="hero-divider"></span>
                <span class="hero-tag">{{ $t('recruitment.page.tag') }}</span>
                <span class="hero-divider hero-divider--hide"></span>
                <span class="hero-since hero-since--hide">{{ $t('recruitment.page.since') }}</span>
            </div>

            <div class="hero-content">
                <span class="hero-eyebrow">{{ $t('recruitment.page.eyebrow') }}</span>
                <h1 class="hero-title">{{ $t('recruitment.header.join-us') }}</h1>
                <p class="hero-lead">
                    {{ $t('recruitment.header.line_1') }} {{ $t('recruitment.header.line_2') }}
                </p>

                <div class="hero-ctas">
                    <a
                        href="https://forms.gle/EMJjbN6953524Rca8"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="hero-cta hero-cta--primary">
                        <span>{{ $t('recruitment.page.application_form') }}</span>
                        <span class="cta-arrow">→</span>
                    </a>
                </div>
            </div>

            <div class="hero-bottom">
                <span class="bottom-meta">{{ $t('recruitment.page.bottom_meta') }}</span>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: "HeaderComponent"
    };
</script>

<style lang="sass" scoped>
    #recruitment
        background: #faf7f1
        color: #0a0828
        font-family: Inter, sans-serif

    /* === HERO === */
    .rec-hero
        position: relative
        width: 100%
        min-height: 100vh
        background: #050316
        color: #fff
        display: flex
        flex-direction: column
        justify-content: space-between
        padding: 110px 0 50px
        overflow: hidden

    .hero-bg
        position: absolute
        inset: 0
        background-image: url('~@/assets/img/components/recruitment/background.webp')
        background-size: cover
        background-position: center
        background-repeat: no-repeat
        filter: saturate(0.85) brightness(0.8) contrast(1.05)
        transform: scale(1.05)

    .hero-overlay
        position: absolute
        inset: 0
        background: radial-gradient(ellipse at 70% 0%, rgba(26, 22, 96, 0.55) 0%, rgba(10, 8, 40, 0.78) 55%, rgba(5, 3, 22, 0.92) 100%)

    .hero-grain
        position: absolute
        inset: 0
        opacity: 0.12
        mix-blend-mode: overlay
        pointer-events: none
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.5'/></svg>")

    .hero-top
        position: relative
        z-index: 2
        display: flex
        align-items: center
        gap: 18px
        padding: 0 56px
        font-size: 12px
        font-weight: 500
        letter-spacing: 0.18em
        text-transform: uppercase
        color: rgba(255, 255, 255, 0.85)

        .hero-divider
            width: 28px
            height: 1px
            background: rgba(255, 255, 255, 0.5)

    .hero-content
        position: relative
        z-index: 2
        max-width: 1280px
        margin: 0 auto
        padding: 0 56px
        width: 100%

        .hero-eyebrow
            display: inline-block
            font-size: 12px
            font-weight: 500
            letter-spacing: 0.24em
            text-transform: uppercase
            color: rgba(255, 255, 255, 0.7)
            margin-bottom: 28px

        .hero-title
            font-family: Raleway, sans-serif
            font-weight: 900
            font-size: clamp(48px, 7.5vw, 110px)
            line-height: 1
            letter-spacing: -0.025em
            margin: 0 0 32px
            color: #fff
            text-transform: lowercase

        .hero-lead
            font-size: clamp(16px, 1.5vw, 19px)
            line-height: 1.6
            font-weight: 400
            color: rgba(255, 255, 255, 0.88)
            max-width: 720px
            margin: 0 0 44px
            text-indent: 0

    .hero-ctas
        display: flex
        flex-wrap: wrap
        gap: 14px

    .hero-cta
        display: inline-flex
        align-items: center
        gap: 14px
        padding: 16px 26px
        border-radius: 999px
        font-family: Inter, sans-serif
        font-weight: 600
        font-size: 13px
        letter-spacing: 0.18em
        text-transform: uppercase
        text-decoration: none
        transition: all 0.25s ease

        .cta-arrow
            font-size: 16px
            transition: transform 0.25s ease

        &--primary
            background: #fff
            color: #0a0828
            border: 1px solid #fff

            &:hover
                background: rgba(255, 255, 255, 0.88)

                .cta-arrow
                    transform: translateY(4px)

        &--ghost
            background: transparent
            color: #fff
            border: 1px solid rgba(255, 255, 255, 0.4)

            &:hover
                background: rgba(255, 255, 255, 0.08)
                border-color: rgba(255, 255, 255, 0.7)

                .cta-arrow
                    transform: translateX(6px)

    .hero-bottom
        position: relative
        z-index: 2
        display: flex
        justify-content: space-between
        padding: 0 56px
        max-width: 1280px
        margin: 0 auto
        width: 100%

        .bottom-meta
            font-size: 11px
            font-weight: 500
            letter-spacing: 0.22em
            text-transform: uppercase
            color: rgba(255, 255, 255, 0.55)

    /* === BLOCKS === */
    .block-light
        background: #faf7f1
        color: #0a0828
        padding: 160px 0 140px

    .block-dark
        background: #0a0828
        color: #fff
        padding: 140px 0 160px

    .block-container
        max-width: 1280px !important
        padding: 0 56px !important

    .section-meta
        display: flex
        align-items: center
        gap: 18px
        margin-bottom: 36px
        font-size: 12px
        font-weight: 500
        letter-spacing: 0.22em
        text-transform: uppercase
        color: #0a0828

        .chapter-num
            font-family: Raleway, sans-serif
            font-weight: 700
            font-size: 14px
            letter-spacing: 0.1em

        .chapter-divider
            width: 36px
            height: 1px
            background: #0a0828
            opacity: 0.4

        .chapter-eyebrow
            opacity: 0.85

        &.section-meta--light
            color: #fff

            .chapter-divider
                background: #fff
                opacity: 0.5

    .block-title
        font-family: Raleway, sans-serif
        font-weight: 900
        font-size: clamp(40px, 5.5vw, 80px)
        line-height: 0.98
        letter-spacing: -0.025em
        margin: 0
        color: #0a0828
        text-transform: lowercase

        &.block-title--light
            color: #fff

    /* === SECTIONS === */
    .sections-header
        display: grid
        grid-template-columns: 1.4fr 1fr
        gap: 80px
        align-items: end
        margin-bottom: 80px

        .sections-lead
            font-size: clamp(15px, 1.1vw, 17px)
            line-height: 1.7
            color: rgba(10, 8, 40, 0.7)
            margin: 0 0 8px
            text-indent: 0
            max-width: 460px

    .sections-grid
        display: grid
        grid-template-columns: repeat(3, 1fr)
        gap: 0
        border-top: 1px solid rgba(10, 8, 40, 0.18)

    .section-card
        display: flex
        flex-direction: column
        gap: 18px
        padding: 36px 32px 36px 0
        border-bottom: 1px solid rgba(10, 8, 40, 0.18)
        border-right: 1px solid rgba(10, 8, 40, 0.18)
        position: relative
        transition: background 0.25s ease

        &:nth-child(3n)
            border-right: none
            padding-right: 0

        &:nth-child(3n+1)
            padding-left: 0

        &:not(:nth-child(3n+1))
            padding-left: 32px

        &:hover
            background: rgba(10, 8, 40, 0.03)

        .card-top
            display: flex
            align-items: baseline
            gap: 16px

            .card-num
                font-family: Raleway, sans-serif
                font-weight: 700
                font-size: 13px
                letter-spacing: 0.1em
                color: rgba(10, 8, 40, 0.45)

            .card-name
                font-family: Raleway, sans-serif
                font-weight: 800
                font-size: clamp(22px, 2vw, 28px)
                line-height: 1.1
                letter-spacing: -0.015em
                color: #0a0828
                margin: 0

        .card-desc
            font-size: 14px
            line-height: 1.7
            color: rgba(10, 8, 40, 0.7)
            margin: 0
            text-indent: 0
            flex: 1

        .card-cta
            display: inline-flex
            align-items: center
            gap: 10px
            font-size: 11px
            font-weight: 600
            letter-spacing: 0.18em
            text-transform: uppercase
            color: #0a0828
            text-decoration: none
            border-bottom: 1px solid transparent
            padding-bottom: 6px
            width: fit-content
            transition: all 0.2s ease

            .card-arrow
                font-size: 14px
                transition: transform 0.2s ease

            &:hover
                border-bottom-color: rgba(10, 8, 40, 0.6)

                .card-arrow
                    transform: translateX(6px)

    /* === FORM === */
    .form-header
        display: grid
        grid-template-columns: 1.4fr 1fr
        gap: 80px
        align-items: end
        margin-bottom: 80px

        .form-lead
            font-size: clamp(15px, 1.1vw, 17px)
            line-height: 1.7
            color: rgba(255, 255, 255, 0.7)
            margin: 0 0 8px
            text-indent: 0
            max-width: 460px

    .rec-form
        max-width: 880px

    .form-row
        display: grid
        grid-template-columns: 1fr 1fr
        gap: 32px

    .form-field
        display: flex
        flex-direction: column
        gap: 10px
        margin-bottom: 28px

        .field-label
            font-size: 11px
            font-weight: 600
            letter-spacing: 0.22em
            text-transform: uppercase
            color: rgba(255, 255, 255, 0.55)

        .field-input
            font-family: Inter, sans-serif
            font-size: 16px
            color: #fff
            background: transparent
            border: none
            border-bottom: 1px solid rgba(255, 255, 255, 0.3)
            padding: 12px 0
            outline: none
            transition: border-color 0.25s ease
            width: 100%

            &::placeholder
                color: rgba(255, 255, 255, 0.4)

            &:focus
                border-bottom-color: #fff

        .field-textarea
            resize: vertical
            min-height: 140px
            line-height: 1.6
            font-family: Inter, sans-serif

    .form-actions
        display: flex
        justify-content: space-between
        align-items: center
        gap: 24px
        margin-top: 24px

    .form-status
        font-size: 13px
        line-height: 1.5
        color: rgba(255, 255, 255, 0.6)

        &--ok
            color: #95ffb6

        &--err
            color: #ff8b8b

    .form-submit
        display: inline-flex
        align-items: center
        gap: 14px
        padding: 16px 28px
        background: #fff
        color: #0a0828
        border: 1px solid #fff
        border-radius: 999px
        font-family: Inter, sans-serif
        font-weight: 600
        font-size: 13px
        letter-spacing: 0.18em
        text-transform: uppercase
        text-decoration: none
        cursor: pointer
        transition: all 0.25s ease

        .cta-arrow
            font-size: 16px
            transition: transform 0.25s ease

        &:hover:not(:disabled)
            background: rgba(255, 255, 255, 0.88)

            .cta-arrow
                transform: translateX(6px)

        &:disabled
            opacity: 0.6
            cursor: not-allowed

    /* === RESPONSIVE === */
    @media (max-width: 1100px)
        .sections-grid
            grid-template-columns: 1fr 1fr

        .section-card
            &:nth-child(3n)
                border-right: 1px solid rgba(10, 8, 40, 0.18)
                padding-right: 32px

            &:nth-child(3n+1)
                padding-left: 32px

            &:nth-child(2n)
                border-right: none
                padding-right: 0

            &:nth-child(2n+1)
                padding-left: 0

        .sections-header,
        .form-header
            grid-template-columns: 1fr
            gap: 24px
            align-items: start

    @media (max-width: 800px)
        .rec-hero
            padding: 100px 0 30px

        .hero-bg
            transform: none

        .hero-top
            padding: 0 28px
            font-size: 11px
            gap: 14px

            .hero-divider--hide,
            .hero-since--hide
                display: none

        .hero-content
            padding: 0 28px

            .hero-title
                font-size: clamp(40px, 11vw, 68px)

        .hero-cta
            font-size: 11px
            padding: 13px 20px
            gap: 10px

        .hero-bottom
            padding: 0 28px

        .block-light
            padding: 100px 0 90px

        .block-dark
            padding: 100px 0

        .block-container
            padding: 0 28px !important

        .sections-header,
        .form-header
            margin-bottom: 56px

        .sections-grid
            grid-template-columns: 1fr

        .section-card
            border-right: none !important
            padding: 28px 0 !important

        .form-row
            grid-template-columns: 1fr
            gap: 0

        .form-actions
            flex-direction: column
            align-items: stretch
            text-align: center

            .form-submit
                justify-content: center
</style>
